module.exports = __webpack_public_path__ + "media/images/common/font_size-a7219e02aa0ff0b669d6a9e3069e1391.png";